var chunkToChildrenMap = {
	"49582": [
		26477,
		99215
	],
	"64863": [
		93675,
		33332,
		20404
	],
	"85013": [
		26477,
		99215
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));